import { Flex, Spin, Table, TableProps } from "antd";
import Card from "antd/es/card/Card";
import React, { useEffect, useState } from "react";
import { getIEHPReplacementClaims } from "../../service/httpsCalls";
import "./billing.scss";
import { createTableConfig } from "./tableConfig";

const ReviewIEHPReplacementClaims = ({ invoiceInfo, parentCallback }) => {
    const [tableHeight, setTableHeight] = React.useState(300);
    const [records, setRecords] = useState<any>([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [filteredRowCount, setFilteredRowCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const tableChanges: TableProps<any>['onChange'] = (_pagination, _filters, _sorter, extra) => {
        if (extra.action == 'filter') {
            setFilteredRowCount(extra.currentDataSource.length);
            return;
        }
        if (extra.action == 'sort') {
            return;
        }
    };

    useEffect(() => {
        handleSearch();
    }, []);

    useEffect(() => {
        if (tableColumns?.length && tableHeight == 300) {
            updateTableHeight();
        }
    }, [tableColumns]);

    const updateTableHeight = () => {
        const updateHeight = () => {
            const container = document.getElementById("table-container-iehp-replacement-claims");
            if (container) {
                const header = document.getElementById("table-container-iehp-replacement-claims")?.getElementsByClassName("ant-table-header")[0].clientHeight ?? 10;
                setTableHeight(container.clientHeight - header);
            }
        };

        window.addEventListener("resize", updateHeight);
        updateHeight();

        return () => window.removeEventListener("resize", updateHeight);
    };

    function handleSearch() {
        setLoading(true);
        setFilteredRowCount(0);

        if (!invoiceInfo?.id) {
            setLoading(false);
            return;
        }

        getIEHPReplacementClaims({
            clientInvoiceSId: invoiceInfo.id
        }, (res) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!';
                setLoading(false);
                setRecords([]);
                parentCallback({
                    isInvalid: true,
                    errorMessage: errorMsg
                });
            } else {
                const items = res?.items ?? [];
                setLoading(false);
                setRecords(items);

                if (res?.columnConfigs) {
                    const cols = createTableConfig(res.columnConfigs);
                    setTableColumns(cols);
                }

                parentCallback({
                    updateDrawerConfig: true,
                    width: items?.length > 0 ? 1250 : 1000
                });
            }
        });
    }

    return (
        <div className={records?.length > 0 ? 'parentDiv' : ''}>
            <div style={{ width: '100%' }}>
                <Card styles={{ body: { padding: '15px', paddingTop: '10px', height: "auto", maxHeight: "calc(100vh - 135px)" } }} loading={loading}>
                    {
                        records?.length > 0 &&
                        <Flex justify="space-between" align="center" style={{ paddingBottom: "5px", paddingTop: "0", background: '#fff' }}>
                            <div style={{ background: '#e6f4ff', padding: '0px 5px', fontWeight: 500 }}>
                                <span style={{ marginRight: '5px', marginLeft: '5px', paddingRight: "5px" }}>
                                    Total: {records.length}
                                </span>
                                {
                                    filteredRowCount > 0 && filteredRowCount !== records.length &&
                                    <span style={{ marginRight: '5px', borderLeft: "1px solid #d4d2d2", paddingLeft: "5px" }}>
                                        Filtered: {filteredRowCount}
                                    </span>
                                }
                            </div>
                        </Flex>
                    }
                    {
                        tableColumns?.length > 0 &&
                        <Spin spinning={loading}>
                            <div id="table-container-iehp-replacement-claims" style={{ height: "calc(100vh - 215px)", width: "100%", overflowY: "hidden", overflowX: "auto" }}>
                                <Table
                                    scroll={{
                                        y: tableHeight,
                                        x: tableColumns.reduce((acc, col: any) => acc + (col.width || 150), 0) + 25,
                                    }}
                                    key="iehpReplacementClaimsTable"
                                    virtual={true}
                                    dataSource={records}
                                    pagination={false}
                                    columns={tableColumns}
                                    onChange={tableChanges}
                                    rowKey={(record, index) => `${record?.clientInvoiceSId ?? ''}-${record?.ctcTripID ?? ''}-${record?.dateOfService ?? ''}-${index}`}
                                    size="small"
                                />
                            </div>
                        </Spin>
                    }
                </Card>
            </div>
        </div>
    );
};

export default ReviewIEHPReplacementClaims;

